// extracted by mini-css-extract-plugin
module.exports = {"counterpart":"az_-Rd","alignEachItemPriceWithError":"az_-Sd","unitPrice":"az_-Td","cartClass":"az_-Ud","mxCart":"az_-Vd","quantityAvailableError":"az_-Wd"};